import './revenueBreakdown.css';

import { useState, useMemo } from 'react';

import Swatch from '../../../assets/icons/swatch/swatch';
import TrendingArrow from '../../../assets/icons/trendingArrow/trendingArrow';
import SpacerBar from '../../spacerBar/spacerBar';

export default function RevenueBreakdown({analyticsTime, organizationData, filteredExpenses, filteredCategories}) {

    const [expenseBar, setExpenseBar] = useState(100);
    const [revenueBar, setRevenueBar] = useState(100);
    const [trendingTitle, setTrendingTitle] = useState('Loading...');
    const [net, setNet] = useState('Loading...');
    const [netDiff, setNetDiff] = useState('00%');
    const [netBool, setNetBool] = useState(false);

    const totalAmountExpense = (filteredExpenses?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0).toFixed(2));

    const setRevenueBars = useMemo(() => {

        const grandTotal = (filteredExpenses?.[analyticsTime]?.reduce((sum, current) => sum + current?.expense_amount, 0)) + organizationData[analyticsTime].revenue;

        setExpenseBar(((totalAmountExpense / grandTotal) * 100).toFixed(0));
        setRevenueBar(((organizationData[analyticsTime].revenue / grandTotal) * 100).toFixed(0));

        const currentBars = [[((totalAmountExpense / grandTotal) * 100).toFixed(0)], [((organizationData[analyticsTime].revenue / grandTotal) * 100).toFixed(0)]]

        if (currentBars[0] < currentBars[1]) {
            setTrendingTitle('Net Profit');
            setNet(`$${(organizationData[analyticsTime].revenue - totalAmountExpense).toFixed(2)}`);
            setNetDiff([[`${currentBars[1]}%`], [` Profit margin`]]);
            setNetBool(true);
        } else {
            setTrendingTitle('Net deficit');
            setNet(`- $${(totalAmountExpense - organizationData[analyticsTime].revenue).toFixed(2)}`);
            setNetDiff([[`${currentBars[0]}%`], [` Deficit margin`]]);
            setNetBool(false);
        }

    }, [filteredCategories, filteredExpenses, analyticsTime, organizationData]);

    return( 
        <div className="revbreakdown card">
            <div className="revbreakdown-container">
                <div className="revbreakdown-left">
                    <p>Revenue Breakdown</p>
                    <div className="swatch-identifier"><Swatch swatch={'var(--secondary-color)'}/><strong>{organizationData[analyticsTime].revenue}</strong></div>
                    <div className="swatch-identifier"><Swatch swatch={'var(--primary-color)'}/><strong>{totalAmountExpense}</strong></div>
                    <div className="revenue-bar-chart">
                        <div className="bar bar-revenue" style={{background: 'var(--secondary-color)', width: `${revenueBar}%`}}><p><strong>{revenueBar}%</strong></p><p><strong>${organizationData[analyticsTime].revenue}</strong></p></div>
                        <div className="bar bar-expenses" style={{background: 'var(--primary-color)', width: `${expenseBar}%`}}><p><strong>{expenseBar}%</strong></p><p><strong>${totalAmountExpense}</strong></p></div>
                    </div>
                </div>
                <div className="revbreakdown-right">
                    <div className="trending-title"><TrendingArrow net={netBool}/><p>{trendingTitle}</p></div>
                    <p><strong>{net}</strong></p>
                    <SpacerBar width="90%" center="auto"/>
                    <p style={netBool ? {color: 'var(--secondary-color-two)'} : {color: 'var(--budget-color)'}}><strong style={netBool ? {color: 'var(--secondary-color-two)'} : {color: 'var(--budget-color)'}}>{netDiff[0]}</strong>{netDiff[1]}</p>
                </div>
            </div>
        </div>
    )
}